module.exports = __webpack_public_path__ + "images/emoji/golf.b9f2b7ace96c6a2c61ac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/golf.png
// module id = dGO9
// module chunks = 2